module.exports = __webpack_public_path__ + "static/media/gameboy.45a0ac34.svg";